// Sample NFT data for Kanpai Pandas collection
export const sprotoNFTs = [
  
    {
    id: 'sproto-gremlins-3249',
    name: 'Sproto Gremlins #3249',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3249.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3248',
    name: 'Sproto Gremlins #3248',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3248.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3247',
    name: 'Sproto Gremlins #3247',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3247.png',
    price: '2.0 ETH'
},
{
    id: 'sproto-gremlins-3245',
    name: 'Sproto Gremlins #3245',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3245.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3246',
    name: 'Sproto Gremlins #3246',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3246.png',
    price: '1.65 ETH'
},
{
    id: 'sproto-gremlins-3244',
    name: 'Sproto Gremlins #3244',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3244.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3243',
    name: 'Sproto Gremlins #3243',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3243.png',
    price: '1.35 ETH'
},
{
    id: 'sproto-gremlins-3242',
    name: 'Sproto Gremlins #3242',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3242.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3241',
    name: 'Sproto Gremlins #3241',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3241.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3240',
    name: 'Sproto Gremlins #3240',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3240.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3239',
    name: 'Sproto Gremlins #3239',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3239.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3238',
    name: 'Sproto Gremlins #3238',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3238.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3237',
    name: 'Sproto Gremlins #3237',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3237.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3236',
    name: 'Sproto Gremlins #3236',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3236.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3235',
    name: 'Sproto Gremlins #3235',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3235.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3234',
    name: 'Sproto Gremlins #3234',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3234.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3233',
    name: 'Sproto Gremlins #3233',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3233.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3231',
    name: 'Sproto Gremlins #3231',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3231.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3232',
    name: 'Sproto Gremlins #3232',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3232.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3230',
    name: 'Sproto Gremlins #3230',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3230.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3228',
    name: 'Sproto Gremlins #3228',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3228.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3229',
    name: 'Sproto Gremlins #3229',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3229.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3227',
    name: 'Sproto Gremlins #3227',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3227.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3226',
    name: 'Sproto Gremlins #3226',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3226.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3225',
    name: 'Sproto Gremlins #3225',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3225.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3224',
    name: 'Sproto Gremlins #3224',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3224.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3223',
    name: 'Sproto Gremlins #3223',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3223.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3221',
    name: 'Sproto Gremlins #3221',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3221.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3222',
    name: 'Sproto Gremlins #3222',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3222.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3220',
    name: 'Sproto Gremlins #3220',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3220.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3219',
    name: 'Sproto Gremlins #3219',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3219.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3218',
    name: 'Sproto Gremlins #3218',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3218.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3217',
    name: 'Sproto Gremlins #3217',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3217.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3216',
    name: 'Sproto Gremlins #3216',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3216.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3214',
    name: 'Sproto Gremlins #3214',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3214.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3213',
    name: 'Sproto Gremlins #3213',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3213.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3212',
    name: 'Sproto Gremlins #3212',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3212.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3211',
    name: 'Sproto Gremlins #3211',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3211.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3210',
    name: 'Sproto Gremlins #3210',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3210.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3209',
    name: 'Sproto Gremlins #3209',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3209.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3207',
    name: 'Sproto Gremlins #3207',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3207.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3208',
    name: 'Sproto Gremlins #3208',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3208.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3205',
    name: 'Sproto Gremlins #3205',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3205.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3206',
    name: 'Sproto Gremlins #3206',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3206.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3203',
    name: 'Sproto Gremlins #3203',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3203.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3202',
    name: 'Sproto Gremlins #3202',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3202.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3204',
    name: 'Sproto Gremlins #3204',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3204.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3200',
    name: 'Sproto Gremlins #3200',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3200.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3199',
    name: 'Sproto Gremlins #3199',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3199.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3198',
    name: 'Sproto Gremlins #3198',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3198.png',
    price: '1.95 ETH'
},
   {
    id: 'sproto-gremlins-3197',
    name: 'Sproto Gremlins #3197',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3197.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3196',
    name: 'Sproto Gremlins #3196',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3196.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3194',
    name: 'Sproto Gremlins #3194',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3194.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3193',
    name: 'Sproto Gremlins #3193',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3193.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3195',
    name: 'Sproto Gremlins #3195',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3195.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3191',
    name: 'Sproto Gremlins #3191',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3191.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3192',
    name: 'Sproto Gremlins #3192',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3192.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3190',
    name: 'Sproto Gremlins #3190',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3190.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3189',
    name: 'Sproto Gremlins #3189',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3189.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3188',
    name: 'Sproto Gremlins #3188',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3188.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3187',
    name: 'Sproto Gremlins #3187',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3187.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3186',
    name: 'Sproto Gremlins #3186',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3186.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3185',
    name: 'Sproto Gremlins #3185',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3185.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3184',
    name: 'Sproto Gremlins #3184',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3184.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3183',
    name: 'Sproto Gremlins #3183',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3183.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3179',
    name: 'Sproto Gremlins #3179',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3179.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3182',
    name: 'Sproto Gremlins #3182',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3182.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3181',
    name: 'Sproto Gremlins #3181',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3181.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3180',
    name: 'Sproto Gremlins #3180',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3180.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3177',
    name: 'Sproto Gremlins #3177',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3177.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3178',
    name: 'Sproto Gremlins #3178',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3178.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3170',
    name: 'Sproto Gremlins #3170',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3170.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3176',
    name: 'Sproto Gremlins #3176',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3176.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3171',
    name: 'Sproto Gremlins #3171',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3171.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3173',
    name: 'Sproto Gremlins #3173',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3173.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3169',
    name: 'Sproto Gremlins #3169',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3169.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3175',
    name: 'Sproto Gremlins #3175',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3175.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3174',
    name: 'Sproto Gremlins #3174',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3174.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3172',
    name: 'Sproto Gremlins #3172',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3172.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3168',
    name: 'Sproto Gremlins #3168',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3168.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3166',
    name: 'Sproto Gremlins #3166',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3166.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3165',
    name: 'Sproto Gremlins #3165',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3165.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3167',
    name: 'Sproto Gremlins #3167',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3167.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3163',
    name: 'Sproto Gremlins #3163',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3163.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3164',
    name: 'Sproto Gremlins #3164',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3164.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3162',
    name: 'Sproto Gremlins #3162',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3162.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3161',
    name: 'Sproto Gremlins #3161',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3161.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3160',
    name: 'Sproto Gremlins #3160',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3160.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3159',
    name: 'Sproto Gremlins #3159',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3159.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3158',
    name: 'Sproto Gremlins #3158',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3158.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3157',
    name: 'Sproto Gremlins #3157',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3157.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3156',
    name: 'Sproto Gremlins #3156',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3156.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3155',
    name: 'Sproto Gremlins #3155',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3155.png',
    price: '1.15 ETH'
},
{
    id: 'sproto-gremlins-3154',
    name: 'Sproto Gremlins #3154',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3154.png',
    price: '1.75 ETH'
},
{
    id: 'sproto-gremlins-3152',
    name: 'Sproto Gremlins #3152',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3152.png',
    price: '0.95 ETH'
},
{
    id: 'sproto-gremlins-3153',
    name: 'Sproto Gremlins #3153',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3153.png',
    price: '1.45 ETH'
},
{
    id: 'sproto-gremlins-3151',
    name: 'Sproto Gremlins #3151',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3151.png',
    price: '1.85 ETH'
},
{
    id: 'sproto-gremlins-3144',
    name: 'Sproto Gremlins #3144',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3144.png',
    price: '1.25 ETH'
},
{
    id: 'sproto-gremlins-3149',
    name: 'Sproto Gremlins #3149',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3149.png',
    price: '1.95 ETH'
},
{
    id: 'sproto-gremlins-3150',
    name: 'Sproto Gremlins #3150',
    image: 'https://ipfs.io/ipfs/bafybeiefzvptnmjns6mq37wgey3hhh5hth7vznnrdrv2km6nkhvs23kthq/3150.png',
    price: '1.15 ETH'
}
];